import React from 'react';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppContent from '../_Shared/Layout/AppContent';
import LinearProgress from '@material-ui/core/LinearProgress';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';


class DatalakeExplorer extends React.Component {

    
    handleInputChange = (name, value) => {
        this.setState( { [name]: value  });
    }

    render() {
        const { dataStreams, loading } = this.props;
        return (
            <AppContent>
                 {
                    loading  && <LinearProgress variant="query" />
                }
                   <DataTableToolbar title="Data Streams" numSelected={0} >
               
                    </DataTableToolbar>
                {
                    dataStreams && dataStreams.items &&
                    <DataTable columns={[ { label: 'Name', field: 'name' },{label: 'Id', field: 'id'},{label: 'Last Updated', field: 'lastUpdated'}, {label: 'Format', field: 'format'}]} rows={
                        dataStreams.items
                    } nextToken={dataStreams.nextToken} />
                }
                
            </AppContent>
            );
    }
}
export default DatalakeExplorer;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Datalake/DatalakeExplorer.js